<!-- 卡片推送 -->
<template>
  <div
    :class="[
      'plv-iar-push-card',
      `plv-iar-push-card--${cardStyle}`,
      { 'plv-iar-push-card--weixinWork--custom': isCustomQr }
    ]"
  >
    <!-- 卡片入口 -->
    <div
      v-if="entryVisible"
      class="plv-iar-push-card__entrance"
    >
      <pendant
        :icon-url="iconUrl"
        :time="popUpLeftTime"
        :show-time="false"
        :tooltip="countdownMsg || iarTrans('pushCard.defaultCountdownMsg')"
        :show-tooltip="!isPushCondition && countdownMsgHideLeftTime > 0"
        :tooltip-position="tipPosition"
        :card-type="cardInfo.cardType"
        :use-lang="_useLang"
        @click="handleEntrance"
        @countdown="handleCountdown"
        @countdown-end="handleCountdownEnd"
      >
        <div
          v-if="popUpLeftTime > 0 || !isCustomType"
          class="plv-iar-push-card__entrance__content"
          :class="[
            {
              'plv-iar-push-card__entrance__content--blue': isQrCode && !isCustomType,
              'plv-iar-push-card__entrance__content--red': !isQrCode && !isCustomType,
            }
          ]"
        >
          <span class="plv-iar-push-card__entrance__content__text">{{ entryText }}</span>
        </div>
      </pendant>
    </div>
    <div
      v-if="visible || iframeVisible"
      ref="cardModal"
      :style="{ '--fullRate': fullRate } "
      :class="{'plv-iar-default-push-card--fullscreen': isFullScreen}"
    >
      <div
        v-if="visible"
        class="plv-iar-push-card__modal"
        :class="[
          'plv-iar-push-card',
          `plv-iar-push-card--${cardStyle}`,
          { 'plv-iar-push-card--weixinWork--custom': isCustomQr }
        ]"
      >
        <div class="plv-iar-push-card__modal__body">
          <template v-if="popUpLeftTime > 0">
            <div class="plv-iar-push-card__modal__content__popup--left-time">
              <div class="plv-iar-push-card__modal__content__popup--title">
                <span>{{ content }}</span>
              </div>

              <div class="plv-iar-push-card__modal__content__popup--time__wrap">
                <div
                  v-for="(item, index) in popupTimeArr"
                  :key="index"
                  class="plv-iar-push-card__modal__content__popup--time"
                  :class="{
                    'plv-iar-push-card__modal__content__popup--time--block': item.type === 'block'
                  }"
                >
                  <span class="plv-font-din-pro-regular">{{ item.value }}</span>
                </div>
              </div>

              <div class="plv-iar-push-card__modal__content__popup--tips">
                <span>{{ iarTrans('pushCard.popupLeftTips1') }}</span><span>{{ this.isQrCode ? iarTrans('pushCard.popupLeftTips3') : iarTrans('pushCard.popupLeftTips2') }}</span><span>{{ iarTrans('pushCard.popupLeftTips4') }}</span>
              </div>

              <div class="plv-iar-push-card__modal__content__popup--button" @click="handleClose">
                <span>{{ iarTrans('pushCard.iKnow') }}</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div
              class="plv-iar-push-card__modal__content"
              :class="{
                'plv-iar-push-card__modal__content--custom': isCustomType,
              }"
              :style="customQrCardBgImgStyle"
              @click="openLink"
            >
              <img
                v-if="isQrCode"
                class="plv-iar-push-card__content__qrcode"
                :src="ossCompress(qrCodeImage, { width: 280 })"
                @touchstart="onTouchStart"
                @touchend="onTouchEnd"/>
              <img v-if="isCustomType" class="plv-iar-push-card__content__bg" :src="ossCompress(cardImage, { width: 500 })" />
              <!-- 卡片倒计时 -->
              <template v-if="hasCountDown">
                <template v-if="isCountDownInRightTop">
                  <div class="plv-iar-push-card__content__time">
                    <!-- 圆环倒计时 -->
                    <svg
                      x="0px"
                      y="0px"
                      width="30px"
                      height="30px"
                      viewBox="0 0 30 30"
                    >
                      <circle
                        class="plv-iar-push-card__content__time-bg"
                        stroke="#FF3F19"
                        fill="none"
                        stroke-width="2"
                        cx="15"
                        cy="15"
                        r="13"
                      />
                      <circle
                        ref="cardCirclePath"
                        class="plv-iar-push-card__content__time-path"
                        stroke="#FED66C"
                        fill="none"
                        stroke-width="2"
                        cx="15"
                        cy="15"
                        r="13"
                      />
                    </svg>
                    <span class="plv-iar-push-card__content__time-number">{{ remainingTime }}</span>
                  </div>
                </template>
                <template v-else>
                  <div
                    :class="[
                      'plv-iar-push-card__content__time--not-circle',
                      `plv-iar-push-card__content__time--${isCountDownPositionTop ? 'top' : 'bottom'}`
                    ]"
                  >
                    <span>{{ remainingTimeTips }}</span>
                  </div>
                </template>
              </template>

              <div class="plv-iar-push-card__content__tip" v-if="isQrCode && cardInfo.imageType !== 'custom'">
                {{ iarTrans('pushCard.qrCodeTip') }}
              </div>
              <div
                v-if="cardStyle === 'redpack'"
                class="plv-iar-push-card__content__open"
                :class="[/^zh_/.test(_useLang) ? 'plv-iar-push-card__content__open--cn' : 'plv-iar-push-card__content__open--en']"
              ></div>
              <p
                class="plv-iar-push-card__content__text"
                :class="[
                  {
                    'plv-iar-push-card__content__text--custom': useNewCustomStyle
                  }
                ]"
              >
                {{ content }}
              </p>
              <button v-if="cardStyle === 'giftbox'" class="plv-iar-push-card__content__btn">{{ iarTrans('pushCard.getNow') }}</button>
              <div
                v-if="isWeixinButton && cardInfo"
                class="plv-iar-push-card__modal__content-wx"
              >
                <wx-link-btn
                  :wx-miniprogram-original-id="cardInfo.wxMiniprogramOriginalId"
                  :wx-miniprogram-link="formatLink(cardInfo.wxMiniprogramLink)"
                />
              </div>
            </div>
          </template>
          <!-- 竖屏关闭按钮-->
          <div class="plv-iar-push-card__modal__close">
            <div class="plv-iar-push-card__modal__close-line"></div>
            <div class="plv-iar-push-card__modal__close-btn" @click="handleClose"></div>
          </div>
          <!-- 横屏关闭按钮-->
          <div class="plv-iar-push-card__modal__close--horizontal">
            <div class="plv-iar-push-card__modal__close-btn" @click="handleClose"></div>
          </div>
        </div>
      </div>

      <template v-if="iframeVisible">
        <mobile-modal
          v-if="isMobile"
          class="plv-iar-push-card__modal plv-iar-push-card__modal__iframe--mobile"
          :width="iframeSize.mobW"
          :height="iframeSize.mobH"
        >
          <iframe
            class="plv-iar-push-card__iframe"
            frameborder="0"
            :src="iframeLink"
          ></iframe>
          <div
            class="plv-iar-push-card__iframe__close"
            @click="handleIframeClose"
          ></div>
        </mobile-modal>
        <pc-modal
          v-else
          class="plv-iar-push-card__modal"
          :width="iframeSize.pcW"
          :height="iframeSize.pcH"
        >
          <iframe
            class="plv-iar-push-card__iframe"
            frameborder="0"
            :src="iframeLink"
          ></iframe>
          <div
            class="plv-iar-push-card__iframe__close"
            @click="handleIframeClose"
          ></div>
        </pc-modal>
      </template>
    </div>

    <toast
      :visible="copyToastVisible"
      text="链接已复制，请在微信或浏览器粘贴打开"
      @hidden="copyToastVisible = false"
    />
  </div>
</template>

<script>
import Pendant from '@/components/pendant/pendant.vue';
import PcModal from '@/components/common/modal/PcModal.vue';
import MobileModal from '@/components/common/modal/MobileModal.vue';
import mixin from './mixin';
import fullscreen from '../../assets/mixins/fullscreen';
import Toast from '@/components/common/toast/Toast.vue';
import WxLinkBtn from './wx-link-btn.vue';
export default {
  props: {
    // 网页全屏， 需要旋转90度适配
    isFullScreen: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Pendant,
    PcModal,
    MobileModal,
    Toast,
    WxLinkBtn,
  },
  mixins: [mixin, fullscreen],
};

</script>
<style lang="scss">
@import '../../assets/styles/basic.scss';

// 入口挂件倒计时
.plv-iar-push-card__entrance__content {
  position: absolute;
  box-sizing: border-box;
  min-width: 40px;
  padding: 1px 6px;
  left: 50%;
  transform: translate(-50%);
  text-align: center;
  bottom: 0;
  color: #ffffff;
  background: rgba(#000, 0.3);
  font-size: 12px;
  border-radius: 8px;
}

.plv-iar-push-card__entrance__content--blue {
  background: #DBECFF;
  color: #1233A7;
}

.plv-iar-push-card__entrance__content--red {
  background: #FFDD8A;
  color: #B32800;
}

.plv-iar-push-card__entrance__content__text {
  white-space: nowrap;
}

.plv-iar-push-card__modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 99;
}
.plv-iar-push-card__modal__body {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.plv-iar-push-card__qrcode-time {
  position: absolute;
  left: 50%;
  top: 0;
  padding: 0 4px;
  height: 18px;
  line-height: 18px;
  border-radius: 0 0 4px 4px;
  text-align: center;
  color: #1233A7;
  font-size: 10px;
  background: #EAF6FF;
  transform: translateX(-50%);
}
.plv-iar-push-card__modal__content {
  width: 220px;
  height: 300px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(./images/hongbao-bg.png);
  border-radius: 4px;
  cursor: pointer;

  &.plv-iar-push-card__modal__content--custom {
    background-image: none;
  }
}
.plv-iar-push-card__content__text {
  position: absolute;
  top: 166px;
  left: 50%;
  transform: translateX(-50%);
  width: 157px;
  height: 56px;
  font-size: 16px;
  margin: 0;
  padding: 0 16px;
  text-align: center;
  font-weight: 400;
  color: #FFF5D6;
  line-height: 24px;
  text-shadow: 0 1px 0 #C80200;
}
.plv-iar-push-card__content__text--custom {
  top: 46px;
  color: #333333;
  text-shadow: none;
}
.plv-iar-push-card__content__bg {
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  position: absolute;
  object-fit: cover;
}

// 倒计时
.plv-iar-push-card__content__time {
  width: 30px;
  height: 30px;
  top: 10px;
  right: 10px;
  position: absolute;
  text-align: center;
  line-height: 30px;

  & svg {
    transform: rotate(-90deg);
  }
}
.plv-iar-push-card__content__time-bg {
  stroke: #FF3F19;
}
.plv-iar-push-card__content__time-path {
  stroke: #FED66C;
  transition: stroke-dashoffset 1s linear;
}
.plv-iar-push-card__content__time-number {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  color: #FED66C;
}

.plv-iar-push-card__content__time--not-circle {
  position: absolute;
  background: rgba(#000, 0.3);
  color: #FFFFFF;
  border-radius: 12px;
  font-size: 12px;
  line-height: 16px;
  padding: 2px 6px;
  left: 50%;
  transform: translateX(-50%);
  min-width: 80px;
  text-align: center;

  span:nth-child(1) {
    display: inline-block;
    min-width: 4px;
    white-space: nowrap;
  }
}

.plv-iar-push-card__content__time--top {
  top: 8px;
}

.plv-iar-push-card__content__time--bottom {
  bottom: 8px;
}

.plv-iar-push-card__content__open {
  background-image: url(./images/btn-open.png);
  width: 78px;
  height: 78px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 46px;
  background-repeat: no-repeat;
  background-size: contain;
}
.plv-iar-push-card__content__open--en {
  background-image: url(./images/btn-open-en.png);
}
.plv-iar-push-card__content__btn {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 92px;
  height: 32px;
  background: linear-gradient(90deg, #FFD89D 0%, #FFB168 100%);
  border-radius: 19px;
  border: none;
  top: 100px;
  cursor: pointer;
  outline: none;

  font-size: 14px;
  font-family: 'PingFangSC-Medium, PingFang SC';
  font-weight: 500;
  color: #AF4500;
  letter-spacing: 1px;
}
.plv-iar-push-card__modal__close {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
}
.plv-iar-push-card__modal__close-btn {
  cursor: pointer;
  width: 32px;
  height: 32px;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url(./images/btn-close.png);
}
.plv-iar-push-card__modal__close-line {
  width: 1px;
  height: 34px;
  background: rgba(255, 255, 255, 0.8);
}
.plv-iar-push-card {
  .plv-iar-pendant__tooltip {
    color: #fff;
    border-color: #FD7232;
  }
  .plv-iar-pendant__tooltip--left {
    background: linear-gradient(231deg, #FF9D4D 0%, #F65F49 100%);
    &::before {
      border-left-color: #FD7232;
    }
    &::after {
      border-left-color: #FF9D4D;
    }
  }
  .plv-iar-pendant__tooltip--right {
    background: linear-gradient(231deg, #F65F49 0%, #FF9D4D 100%);
    &::before {
      border-right-color: #FD7232;
    }
    &::after {
      border-right-color: #FF9D4D;
    }
  }
  .plv-iar-pendant__countdown {
    color: rgba(255, 255, 255, 0.8);
  }
}
.plv-iar-push-card--redpack {
  .plv-iar-push-card__modal__content {
    background-image: url(./images/hongbao-bg.png);
  }
}
.plv-iar-push-card--giftbox {
  .plv-iar-pendant__tooltip--left {
    background: linear-gradient(231deg, #F6A125 0%, #FD8121 100%);
  }
  .plv-iar-pendant__tooltip--right {
    background: linear-gradient(231deg, #FD8121 0%, #F6A125 100%);
    &::after {
      border-right-color: #F6A125;
    }
  }
  .plv-iar-push-card__modal__content {
    background-image: url(./images/gift-box-bg.png);
  }
  .plv-iar-push-card__content__text {
    top: 46px;
    font-size: 16px;
    color: #E94D00;
    text-shadow: none;
  }
  .plv-iar-push-card__content__time-path {
    stroke: #FFC94B;
  }
  .plv-iar-push-card__content__time-bg {
    stroke: #FFE2C7;
  }
  .plv-iar-push-card__content__time-number {
    color: #FB9B26;
  }
}

.plv-iar-push-card--weixinWork {
  .plv-iar-push-card__modal__content {
    background-image: url(./images/qr-code-bg.png);
    position: relative;

    .plv-iar-push-card__content__tip {
      position: absolute;
      left: 50%;
      bottom: 42px;
      font-size: 10px;
      color: #1233A7;
      width: 100%;
      text-align: center;
      transform: translateX(-50%);
    }
    .plv-iar-push-card__content__qrcode {
      width: 132px;
      height: 132px;
      position: absolute;
      left: 45px;
      top: 100px;
      border-radius: 4px;
      object-fit: cover;
    }

    .plv-iar-push-card__content__text {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      top: 35px;
      left: 50%;
      width: 164px;
      color: #1233A7;
      text-shadow: none;
      padding: 0;
      line-height: 24px;
    }
  }

  .plv-iar-pendant__tooltip {
    color: #fff;
    border-color: #80ACFF;
  }
  .plv-iar-pendant__tooltip--left {
    background: linear-gradient(103deg, #80ACFF 5%, #5590FF 99%);
    &::before {
      border-left-color: #80ACFF;
    }
    &::after {
      border-left-color: #5590FF;
    }
  }
  .plv-iar-pendant__tooltip--right {
    background: linear-gradient(103deg, #80ACFF 5%, #5590FF 99%);
    &::before {
      border-right-color: #80ACFF;
    }
    &::after {
      border-right-color: #5590FF;
    }
  }
}

.plv-iar-push-card--weixinWork--custom {
  .plv-iar-push-card__modal__content {
    .plv-iar-push-card__content__text {
      color: #333;
      font-weight: 500;
    }

    .plv-iar-push-card__content__tip {
      color: #333;
    }

    .plv-iar-push-card__qrcode-time {
      background: rgba(#000, 0.3);
      color: #fff;
    }
  }
}

.plv-iar-push-card__modal__close--horizontal {
  display: none;
  position: absolute;
  right: -47px;
  top: 0;
}
@media screen and (min-aspect-ratio: 4/3) {
  .plv-iar-push-card__modal__close {
    display: none;
  }
  .plv-iar-push-card__modal__close--horizontal {
    display: block;
  }
}
.plv-iar-push-card__iframe {
  width: 100%;
  height: 100%;
  position: relative;
  outline: none;
}
.plv-iar-push-card__iframe__close {
  position: absolute;
  right: 10px;
  top: 10px;
  border-radius: 100%;
  width: 32px;
  height: 32px;
  background: url(./images/btn-close.png);
  background-size: 100% 100%;
  cursor: pointer;
}
.plv-iar-push-card__modal__iframe--mobile {
  .plv-iar-modal__main {
    transform: none;
    top: initial;
  }
}

.plv-iar-default-push-card--fullscreen {
  position: absolute;
  width: 100vh;
  height: 100vw;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(90deg);
  .plv-iar-push-card__modal__close {
    display: none;
  }
  .plv-iar-push-card__modal__close--horizontal {
    display: block;
  }
}
.plv-iar-push-card__modal__content-wx {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  cursor: pointer;
}

// 等待弹窗展示倒计时
.plv-iar-push-card__modal__content__popup--left-time {
  width: 220px;
  height: 300px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(./images/popup-up-left.png);
  border-radius: 4px;
  cursor: pointer;
}

.plv-iar-push-card__modal__content__popup--title {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 56px;
  width: 80%;
  height: 56px;
  left: 50%;
  transform: translate(-50%);
  text-align: center;
  font-weight: 500;
  line-height: 22px;
}

.plv-iar-push-card__modal__content__popup--time__wrap {
  position: absolute;
  width: 100%;
  display: flex;
  top: 126px;
  justify-content: center;
  align-items: center;
}

.plv-iar-push-card__modal__content__popup--time {
  &:not(.plv-iar-push-card__modal__content__popup--time--block) {
    background: rgba($color: #FF273D, $alpha: 0.1);
    border-radius: 4px;

    span {
      min-width: 20px;
    }
  }

  &:not(:last-child) {
    margin-right: 6px;
  }

  span {
    display: block;
    font-size: 34px;
    font-weight: 500;
    color: #FF273D;
    padding: 0 8px;
  }
}

.plv-iar-push-card__modal__content__popup--time--block {
  span {
    padding: 0 2px;
  }
}

.plv-iar-push-card__modal__content__popup--tips {
  position: absolute;
  top: 185px;
  box-sizing: border-box;
  font-size: 12px;
  color: #666666;
  width: 100%;
  text-align: center;
  line-height: 16px;
  padding: 10px;

  span:nth-child(2) {
    color: #FF273D;
  }
}

.plv-iar-push-card__modal__content__popup--button {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 22px;
  font-size: 16px;
  font-weight: 500;
  background: linear-gradient(106deg, #FF273D 0%, #FE83AE 100%);
  border-radius: 25px;

  span {
    display: block;
    padding: 11px 41px;
    color: #FFFFFF;
    white-space: nowrap;
  }
}
</style>
